module.exports = __webpack_public_path__ + "img/index_zyMarket_img1.81d04970.png";